﻿import React, { useState, useEffect } from 'react';
import { NavLink } from "react-router-dom";
import { MethodSearch } from '../../models/Methods/method-search';
import MethodHtmlDescriptionComponent from '../Methods/MethodHtmlDescriptionComponent';
import GlobalDialog from '../Modal/GlobalDialog';
import { BenchSheetTechnologyType, ModalMessageType } from '../../models/enums';
import { Technology } from '../../models/technology';
import { CrudFunctions } from '../../utilities/crud-functions';
import { ModalMetadata } from '../../models/modal-metadata';

import DataGrid, {
    Column,
    Selection,
    Paging,
    HeaderFilter,
    FilterRow,
    LoadPanel,
    Button as ColumnButton,
} from 'devextreme-react/data-grid';

import TextBox from 'devextreme-react/text-box';
import SelectBox from 'devextreme-react/select-box';
import { Button } from 'devextreme-react/button';

export interface Props {
    defaultTechnology?: BenchSheetTechnologyType;
    onApplySelection?: (method: MethodSearch) => void;
    onCancel?: () => void;
}

export default function SearchMethodsComponent(props: Props) {
    const [methods, setMethods] =
        useState<MethodSearch[]>();

    const [selectedMethod, setSelectedMethod] =
        useState<MethodSearch>();

    const [partNumberFilter, setPartNumberFilter] =
        useState<string>();

    const [technologies, setTechnologies] =
        useState<Technology[]>();

    const [selectedTechnology, setSelectedTechnology] =
        useState<BenchSheetTechnologyType>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, []);

    useEffect(() => {
        setSelectedTechnology(props.defaultTechnology);
    }, [props.defaultTechnology]);

    return (
        <div id="searchMethodsComponentContainer" style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <div className="pw-comp-row" style={{ height: "5rem" }}>
                <div className="pw-form-unit pw-comp-20">
                    <div className="pw-form-unit-label">Part Number</div>
                    <TextBox id="partNumber" className="textbox"
                        onValueChanged={partNumberFilterValueChanged}
                        showClearButton={true}
                        placeholder="part number" value={partNumberFilter ? partNumberFilter : undefined} />
                </div>

                <div className="pw-form-unit pw-comp-20">
                    <div className="pw-form-unit-label">Technology</div>
                    <SelectBox id="technologyId" className="selectbox"
                        placeholder='technology'
                        displayExpr='name' valueExpr='technologyId'
                        onValueChanged={onTechnologyChanged}
                        value={selectedTechnology ?
                            selectedTechnology : null}
                        dataSource={technologies ? technologies : []} />
                </div>

                <Button id="searchButton" text="Search" icon="find" type="success"
                    className="pw-row-button-09"
                    hint="search"
                    height='1.6rem'
                    onClick={onSearchMethodClick} />
            </div>

            <div style={{ height: "100%" }}>

                <div className="pw-comp-row" style={{height: "40%"}} >
                    <DataGrid
                        height="100%"
                        dataSource={methods ? methods : []}
                        onSelectionChanged={methodSelectionChanged}
                        keyExpr="methodId"
                        wordWrapEnabled={true}
                        allowColumnResizing={true}
                        columnResizingMode='widget'
                        rowAlternationEnabled={true}
                        showRowLines={true}
                        showBorders={true}>

                        <LoadPanel enabled={true} />
                        <Selection mode='single' />
                        <HeaderFilter visible={true} />
                        <FilterRow visible={true} />
                        <Paging enabled={false} />

                        <Column dataField='partNumber' caption="Part #" width='12rem' />
                        <Column dataField='methodName' width='10rem' />
                        <Column dataField='versionNumber' caption="Version #" width='10rem' />
                        <Column dataField='methodStateName' caption="Method State" width='10rem' />

                        <Column />


                    </DataGrid>
                </div>

                <div style={{ height: "60%"}} >
                <div style={{ overflowY: "scroll" }}>
                    <MethodHtmlDescriptionComponent methodId={selectedMethod && selectedMethod.methodId ?
                        selectedMethod.methodId : undefined} height="100%" />
                    </div>
                </div>
            </div>

            <div className="pw-comp-row" style={{ height: "6rem" }}>
                <div className="pw-centered-buttons-container">
                    <Button id="applySelectionButton"
                        className="pw-button"
                        text="Apply" type="success"
                        hint="apply selection"
                        height={'2.6em'}
                        onClick={onApplyClick} />

                    <Button id="cancelButton"
                        className="pw-button"
                        text="Cancel" type="normal"
                        hint="cancel"
                        height={'2.6em'}
                        onClick={onCancelClick} />
                </div>
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    function partNumberFilterValueChanged(e: any) {
        setPartNumberFilter(e.value);
    }

    function onTechnologyChanged(e: any) {
        setSelectedTechnology(e.value);
    }

    function onApplyClick(e: any) {
        if (selectedMethod && props.onApplySelection)
            props.onApplySelection(selectedMethod);
    }

    function onCancelClick(e: any) {
        if (props.onCancel)
            props.onCancel();
    }

    function methodSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0)
            setSelectedMethod(e.selectedRowsData[0]);
    }

    function onSearchMethodClick(e: any) {
        if (partNumberFilter && selectedTechnology)
            getMethods(selectedTechnology, partNumberFilter);
    }

    async function getTechnologies() {
        await CrudFunctions.getData("common/benchsheettechnologytypes")
            .then(data => {
                setTechnologies(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Technology List");
            });
    }

    async function getMethods(technologyId: BenchSheetTechnologyType, partNumber: string) {
        await CrudFunctions.getData(`methods/methodsbysearch/${technologyId}/${partNumber}`)
            .then((data) => {

                console.log("METHS:");
                console.log(data);

                setMethods(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Matching Methods");
            });
    }

    function getAllData() {
        getTechnologies();
    }

    //rendering

    function gotoMethodColumnButtonRender(e: any) {
        let method = e.data as MethodSearch;

        if (method) {
            let path = `/methods-form-demo/${method.methodId}`;

            return <NavLink to={path} className="datagrid-icon-link"><span className="dx-icon-edit datagrid-icon"></span></NavLink>
        }
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}


